<template>
  <div class="video-preview-btn position-relative">
    <lazy-image
      :src="image_src"
      :lazy_src="image_lazy_src"
      img_border_radius
      cover_img
      alt="video image"/>
    <div
      v-if="!hide_button"
      class="video-preview-btn--play-btn cursor_pointer"
      @click="$emit('click', $event)">
      <play-video-icon/>
    </div>
  </div>
</template>

<script>
import LazyImage from "./LazyImage.vue";
import PlayVideoIcon from "../icons/PlayVideoIcon.vue";

export default {
  name: "VideoPreviewWithPlayBtn",
  components: {PlayVideoIcon, LazyImage},
  props: {
    image_src: {
      type: String,
      default: ''
    },
    image_lazy_src: {
      type: String,
      default: ''
    },
    hide_button: {
      type: Boolean,
      default: false
    },
  }
}
</script>
